module.exports = __webpack_public_path__ + "static/q6-b95d092d91475947d0a294d7d5539ba0.png";